'use es6';

// TODO move to ecosystem-marketplace-core
import Immutable from 'immutable';
import { cleanObject } from 'marketplace-ui-common/utils/formatters';
const EMPTY_SET = Immutable.Set();
const defaults = {
  credentials: EMPTY_SET,
  connectionType: null,
  firstPublishedAt: 0,
  homemade: false,
  installsCount: 0,
  slug: '',
  sourceId: '',
  typeId: 1,
  portalId: 0
};
class ThinOffering extends Immutable.Record(defaults) {
  constructor(json = {}) {
    super(cleanObject(json));
  }
}
export default ThinOffering;